module.exports = __webpack_public_path__ + "img/merloimage.cb45f651.png";